import { verificationCodeValidationMessages } from '@consumer-frontend/nc-utils';

import { NcButtonStyledAsLink } from '../NcButtonStyledAsLink';

export type NcExpiredCodeErrorMessagePropsT = {
  handleSendCode: () => Promise<void>;
};

export type NcExpiredCodeErrorMessageT = React.FC<NcExpiredCodeErrorMessagePropsT>;

export const NcExpiredCodeErrorMessage: NcExpiredCodeErrorMessageT = ({
  handleSendCode,
}) => {
  return (
    <span>
      {verificationCodeValidationMessages.expired}{' '}
      <NcButtonStyledAsLink onClick={handleSendCode}>
        Send a new code
      </NcButtonStyledAsLink>.
    </span>
  );
};
